export const ImageLoader = (path, onload) => new Promise((resolves, rejects) => {
	let image = new Image();
	image.onload = () => onload({image:image, status: true, erro:""}); 
	
	try{
		image.src = require("../../"+path);
		resolves(image);
	}catch(erro){
		rejects(erro);
	}
});
